import { render, staticRenderFns } from "./Manual.vue?vue&type=template&id=fb28bc26&scoped=true&lang=pug&"
import script from "./Manual.vue?vue&type=script&lang=js&"
export * from "./Manual.vue?vue&type=script&lang=js&"
import style0 from "./Manual.scss?vue&type=style&index=0&id=fb28bc26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb28bc26",
  null
  
)

export default component.exports